import * as React from "react";

import {
  Sidebar,
  SidebarInset,
  useSidebar,
} from "@needl-ai/common/components/ui/sidebar";
import { cn } from "@needl-ai/common/lib/utils";

import { AppSidebarHeader } from "./AppSidebarHeader";
import { ToggleSidebarButton } from "./ToggleSidebarButton";
import { UserProfile } from "./UserProfile";

export const AppSidebar: React.FC<AppSidebarProps> = ({
  children,
  onLogoClick,
}) => {
  const { state } = useSidebar();
  const isSidebarOpen = state === "expanded";

  return (
    <Sidebar
      collapsible="icon"
      className="border-r bg-sidebar border-sidebar-border transition-all duration-300 ease-in-out backdrop-blur-sm"
    >
      <AppSidebarHeader onLogoClick={onLogoClick} />
      {!isSidebarOpen && (
        <div className="px-2 pt-4">
          <div className="flex justify-center">
            <ToggleSidebarButton />
          </div>
        </div>
      )}

      <div className="flex-1 flex flex-col min-h-0 overflow-hidden">
        {children}
      </div>

      <div>
        <div
          className={cn(
            "border-t border-sidebar-border bg-sidebar backdrop-blur-sm",
            isSidebarOpen ? "p-4" : "p-2"
          )}
        >
          <UserProfile />
        </div>
      </div>
    </Sidebar>
  );
};

export { SidebarInset };

type AppSidebarProps = {
  children: React.ReactNode;
  onLogoClick?: () => void;
};
